export const text = {
  invalidSize: 'El tamaño de la imagen es mayor a 2MB'
};
